import { scheduleRender } from '@features/analysis/rendering/Panels/renderState';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

export interface iTerritory {
  series_id: string;
  json: object;
}
export interface iTerritory_input {
  branchid: number;
  input_idx: number;
}

const getTerritoryApi = async (series_id: string) => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/series/myocardial/${series_id}`;
};

async function ToFormData(info: iTerritory) {
  const formData = new FormData();
  const json_input = JSON.stringify(info.json);

  const blob = new Blob([json_input], { type: 'application/json' });
  formData.append('file', blob, 'territory.json');
  return formData;
}

export async function send_territory_info(
  accessToken: string,
  info: iTerritory,
) {
  const url = await getTerritoryApi(info.series_id);

  const send_info = await ToFormData(info);
  const res: AxiosResponse = await axios({
    method: 'post',
    url: url,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    data: send_info,
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  console.log(res);

  if (res.status == 201) {
    const territory_result = res.data['data'];
    scheduleRender('Surface3D', {
      type: 'territory_result',
      result: territory_result,
    });
    return [true, territory_result];
  }
  return [false, undefined];
}
async function make_dummy_json(info: iTerritory_input) {
  return {
    Territory: info,
  };
}
export async function run_myocardial(
  accessToken: string,
  series_id: string,
  info: iTerritory_input,
) {
  const json_info = await make_dummy_json(info);
  const [operation_result, territory_result] = await send_territory_info(
    accessToken,
    {
      series_id: series_id,
      json: json_info,
    },
  );

  console.log('run status: ', operation_result);
  console.log('territory result: ', territory_result);
}
